import { render, staticRenderFns } from "./AlipayAuth.vue?vue&type=template&id=2f384004&scoped=true&"
import script from "./AlipayAuth.vue?vue&type=script&lang=js&"
export * from "./AlipayAuth.vue?vue&type=script&lang=js&"
import style0 from "./AlipayAuth.vue?vue&type=style&index=0&id=2f384004&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f384004",
  null
  
)

export default component.exports